module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title title-bg-bird"
  }, [_c('span', [_vm._v("相關夥伴 " + _vm._s(this.getCategory.title))])]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row strict7"
  }, _vm._l((_vm.partner), function(row, index) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-4"
    }, [_c('div', {
      staticClass: "articles-box news-box"
    }, [_c('a', {
      attrs: {
        "href": row.link,
        "target": "_blink"
      }
    }, [_c('figure', {
      staticClass: "articles-fitimg"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/partner/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text text-center"
    }, [_c('h5', {
      staticClass: "title text-primary"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('p', {
      staticClass: "txt",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-banner inner-banner-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "articles-box"
  }, [_c('figure', {
    staticClass: "pic articles-pic fitimg mb-0"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "https://admin.weddingsung.com/upload/slide/88311b59e2e2c107d44366e24d81f644.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06dd8678","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Partner.vue
// module id = 153
// module chunks = 1